module.exports = __webpack_public_path__ + "media/images/icons/help-circle-bee6012f0c53098c62419adc3ccefa14.svg";